import { NgModule } from '@angular/core';
import { SoudotecItemsInputFormComponent } from './items-input-form/soudotec-items-input-form.component';
import { SoudotecItemsInputDesignComponent } from './items-input-design/soudotec-items-input-design.component';
import { SoudotecItemsInputResultComponent } from './items-input-result/soudotec-items-input-result.component';
import { DynamicSoudotecItemsInputComponent } from './dynamic-soudotec-items-input.component';
import { SoudotecItemsInputArticlesDialog } from './items-input-articles-dialog/soudotec-items-input-articles-dialog.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { DropdownModule } from '../../dropdown/dropdown.module';
import { KendoModule } from '../../kendo.module';
import { NewlandScannerModule } from '../../newland-scanner/newland-scanner.module';
import { SoudotecItemsInputService } from './soudotec-items-input.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FamocoScanLaserModule } from '../../famoco-scan-laser/famoco-scan-laser.module';

@NgModule({
    declarations: [
        SoudotecItemsInputResultComponent,
        SoudotecItemsInputDesignComponent,
        SoudotecItemsInputFormComponent, DynamicSoudotecItemsInputComponent,
        SoudotecItemsInputArticlesDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSelectModule,
        MatTableModule,
        MatProgressBarModule,
        DropdownModule,
        KendoModule,
        FamocoScanLaserModule,
        NgxMatSelectSearchModule,
        ScrollingModule
    ],
    entryComponents: [
        DynamicSoudotecItemsInputComponent,
        SoudotecItemsInputArticlesDialog
    ],
    providers: [
        SoudotecItemsInputService
    ]
})
export class SoudotecItemsInputModule {}